import "./advancedDropdown.css"
import TextButton from "../../../../components/Buttons/TextButton/TextButton";
import CloseButton from "../../../../components/Buttons/CloseButton/closeButton";
import TimeDropdown from "../TimeDropdown/TimeDropdown";
import ContractDropdown from "../ContractDropdown/ContractDropdown";
import MomsDropdown from "../MomsDropdown/MomsDropdown";

export default function AdvancedDropdown({ 
  selectedTime, 
  setSelectedTime, 
  selectedContractType, 
  setSelectedContractType, 
  selectedMoms, 
  setSelectedMoms, 
  closeAdvancedDropdown }) {

  const handleClearButtonClick = () => {
    setSelectedTime([]);
    setSelectedContractType([]);
    setSelectedMoms([]);
    sessionStorage.removeItem("selectedTime");
    sessionStorage.removeItem("selectedContractType");
    sessionStorage.removeItem("selectedMoms");
  };

  return (
    <div className="advanced-dropdown">
      <div className="advanced-dropdown-header">
        <p>Avancerat filter</p>
        <CloseButton onClick={closeAdvancedDropdown} />
      </div>
      <hr/>
      <div className="advanced-content-wrapper">
        <div className="advanced-dropdowns-wrapper">
          <TimeDropdown selectedTime={selectedTime} setSelectedTime={setSelectedTime} />
          <ContractDropdown selectedContractType={selectedContractType} setSelectedContractType={setSelectedContractType} />
          <MomsDropdown selectedMoms={selectedMoms} setSelectedMoms={setSelectedMoms} />
        </div>
      </div>
      {/* <hr /> */}
      <div className="advanced-button-wrapper">
        <TextButton label="Rensa alla filter" onClick={handleClearButtonClick} />
      </div>
    </div>
  )
}